import React from 'react';
import { Cardapio } from 'modulos/cardapio/containers';

export const CardapioAcompanharPedido = () => {
  return <Cardapio visualizacao="acompanharPedido" />;
};  
